import axios from '@/utils/axios';
import { DashboardData, DashboardDataQuery, DashboardResponse } from '../types';

export const emptyDashboardData: DashboardData = {
  meta: {
    timezone: 'Europe/London',
    range: { preset: '30d', startDate: '', endDate: '', label: '' },
    previousRange: {
      startDate: '',
      endDate: '',
      label: '',
      comparisonLabel: '',
    },
    listLimit: 5,
    generatedAt: '',
  },
  summary: {
    revenueBilled: {
      amount: 0,
      collectedAmount: 0,
      outstandingAmount: 0,
      previousAmount: 0,
      changePercent: 0,
    },
    providerPayments: {
      amount: 0,
      previousAmount: 0,
      changePercent: 0,
    },
    profit: {
      amount: 0,
      previousAmount: 0,
      changePercent: 0,
      revenueAmount: 0,
      providerPaymentsAmount: 0,
    },
    newClients: { count: 0, previousCount: 0, delta: 0 },
    lostClients: {
      count: 0,
      previousCount: 0,
      delta: 0,
      isRelevant: false,
      minimumRangeDays: 30,
      reason:
        'Lost clients is only relevant for reporting ranges of 30 days or longer.',
    },
    sessions: { count: 0, previousCount: 0, delta: 0, avgJobValue: 0 },
  },
  charts: {
    revenue: [],
    newClients: [],
    bookingStatuses: [],
    revenueByService: [],
  },
  todaySessions: {
    total: 0,
    remaining: 0,
    items: [],
  },
  attention: [],
  topLocations: {
    total: 0,
    remaining: 0,
    items: [],
  },
  operations: {
    avgJobValue: 0,
    avgDurationHours: 0,
    cancellationRate: 0,
    couponsUsed: 0,
    couponImpactAmount: 0,
  },
  cleaners: {
    totalActive: 0,
    remaining: 0,
    items: [],
  },
};

const DEFAULT_DASHBOARD_QUERY: DashboardDataQuery = { range: '30d' };

function buildDashboardParams(query: DashboardDataQuery) {
  if (query.start_date && query.end_date) {
    return {
      start_date: query.start_date,
      end_date: query.end_date,
    };
  }

  return {
    range: query.range ?? DEFAULT_DASHBOARD_QUERY.range,
  };
}

export async function getDashboardData(
  query: DashboardDataQuery = DEFAULT_DASHBOARD_QUERY
): Promise<DashboardData> {
  const response = await axios.get<DashboardResponse>('/me/dashboard/data', {
    params: buildDashboardParams(query),
  });

  return response.data.data ?? emptyDashboardData;
}
